import React, { Component } from "react";
import { FiChevronDown } from "react-icons/fi";
import { BsDot } from "react-icons/bs";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
} from "reactstrap";
import { changeOrderStatus } from "./services";
import DatePicker from "react-datepicker2";
import momentJalaali from "moment-jalaali";
import times from "./times";

class OrderDetailFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusModal: false,
      acceptModal: false,
      setTimeModal: false,
      startSelect: false,
      endSelect: false,
      shopUid: window.location.pathname.split("/")[2],
      orderId: window.location.pathname.split("/")[4],
      shipping_time_end: "",
      shipping_time: "",
      start_time: "",
      end_time: "",
      date: momentJalaali(),
      end_times: [],
      start_times: [],
    };
  }
  componentDidMount() {
    this.setStartTimes();
  }
  setEndTimes() {
    let new_times = [];
    times.map((time, t) => {
      if (time > this.state.start_time) {
        new_times.push(time);
      }
    });
    this.setState({
      end_times: new_times,
    });
    if (!this.state.end_time || this.state.start_time > this.state.end_time) {
      this.setState({ end_time: new_times[0] });
    }
  }
  setStartTimes() {
    let new_times = [];
    if (
      this.state.date.format("jYYYY/jM/jD") ===
      momentJalaali().format("jYYYY/jM/jD")
    ) {
      times.map((time, t) => {
        if (time > momentJalaali().format("HH:mm")) {
          new_times.push(time);
        }
      });
      this.setState(
        {
          start_times: new_times,
          start_time: new_times[0],
        },
        () => this.setEndTimes()
      );
    } else {
      this.setState(
        {
          start_times: times,
        },
        () => this.setEndTimes()
      );
    }
  }
  changeStatus() {
    let params = {
      status: this.state.selectedStatus,
      shipping_time: this.state.shipping_time,
      shipping_time_end: this.state.shipping_time_end,
    };
    if (this.state.selectedStatus === 1) {
      params.shipping_time = `${this.state.date.format("jYYYY-jM-jD")} ${
        this.state.start_time
      }`;
      params.shipping_time_end = `${this.state.date.format("jYYYY-jM-jD")} ${
        this.state.end_time
      }`;
    }
    changeOrderStatus(this.state.shopUid, this.state.orderId, params).then(
      (items) => {
        items && this.props.setOrderChange(items);
      }
    );
  }
  render() {
    return (
      <div>
        <footer
          className="position-fixed bg-white py-2-3 px-4"
          style={{ right: "0", left: "0", bottom: "0", zIndex: "9999999" }}
        >
          <div className="row mx-0">
            <div className="col px-0 fw-bold align-self-center fs-5">
              وضعیت کنونی سفارش:
            </div>
            <div className="col-auto px-0">
              <button
                onClick={() =>
                  this.props.status !== 5 &&
                  this.setState({ statusModal: true })
                }
                className={`btn rounded28 py-2 ${
                  this.props.status === 2 || this.props.status === 1
                    ? "bg-purple"
                    : this.props.status === 0
                    ? "bg-secondary"
                    : this.props.status === 5
                    ? "bg-danger"
                    : this.props.status === 4
                    ? "bg-color-main"
                    : "bg-color-second"
                } text-white fw-bold`}
                style={{
                  backgroundColor: this.props.status_obj.background_color,
                  color: this.props.status_obj.color,
                }}
              >
                {this.props.status_obj.text}
                {this.props.status !== 5 && <FiChevronDown size={22} />}
              </button>
            </div>
          </div>
        </footer>
        <Modal
          dir="rtl"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom w-auto rounded-top-14"
          isOpen={this.state.statusModal}
          toggle={() => this.setState({ statusModal: !this.state.statusModal })}
          zIndex="9999999999"
        >
          <ModalBody className="p-3">
            {(this.props.status === 0 ||
              this.props.status === 1 ||
              this.props.status === 2) && (
              <div
                className="p-3 btn fw-bold d-block text-end vh"
                onClick={() => {
                  this.setState({
                    selectedStatus: 1,
                    statusModal: false,
                    setTimeModal: true,
                  });
                }}
              >
                <BsDot
                  size={30}
                  className={
                    this.props.status === 0 ? "text-danger" : "text-secondary"
                  }
                />
                <span className="me-2 fs-6 text-gray">
                  {this.props.status === 0
                    ? "انتخاب زمان ارسال"
                    : "تغییر زمان ارسال"}
                </span>
              </div>
            )}
            {(this.props.status === 0 || this.props.status === 1) && (
              <div
                className="p-3 btn fw-bold d-block text-end"
                onClick={() => {
                  this.setState({
                    selectedStatus: 2,
                    statusModal: false,
                    acceptModal: true,
                  });
                }}
              >
                <BsDot size={30} className="text-purple" />
                <span className="me-2 fs-6 text-gray">در حال آماده سازی</span>
              </div>
            )}
            {(this.props.status === 0 ||
              this.props.status === 1 ||
              this.props.status === 2) && (
              <div
                className="p-3 btn fw-bold d-block text-end"
                onClick={() => {
                  this.setState({
                    selectedStatus: 3,
                    statusModal: false,
                    acceptModal: true,
                  });
                }}
              >
                <BsDot size={30} className="color-second" />
                <span className="me-2 fs-6 text-gray">ارسال شد</span>
              </div>
            )}
            {this.props.status !== 4 && (
              <div
                className="p-3 btn fw-bold d-block text-end"
                onClick={() => {
                  this.setState({
                    selectedStatus: 4,
                    statusModal: false,
                    acceptModal: true,
                  });
                }}
              >
                <BsDot size={30} className="color-main" />
                <span className="me-2 fs-6 text-gray">تکمیل شد</span>
              </div>
            )}
            <div
              className="p-3 btn fw-bold d-block text-end"
              onClick={() => {
                this.setState({
                  selectedStatus: 5,
                  statusModal: false,
                  acceptModal: true,
                });
              }}
            >
              <BsDot size={30} className="text-danger" />
              <span className="me-2 fs-6 text-gray">لغو شده</span>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          dir="rtl"
          zIndex="99999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.state.acceptModal}
          toggle={() => {
            this.setState({ acceptModal: false });
          }}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-1 mb-3">
              <p className="fw-bolder">تغییر وضعیت سفارش</p>
              <p className="text-muted">
                پس از تغییر وضعیت سفارش، برای مشتری پیامک ارسال خواهد شد و دیگر
                قادر به بازگشت نخواهید بود، وضعیت سفارش را تغییر کند؟
              </p>
            </div>

            <div className="col-6 px-1">
              <button
                className="btn py-2 w-100 text-danger fw-bold"
                onClick={() => {
                  this.setState({ acceptModal: false });
                  this.changeStatus();
                }}
              >
                بله
              </button>
            </div>
            <div className="col-6 px-1">
              <button
                className="btn py-2 w-100 rounded28 border text-muted fw-bold"
                onClick={() => {
                  this.setState({ acceptModal: false });
                }}
              >
                انصراف
              </button>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.state.setTimeModal}
          toggle={() => {
            this.setState({ setTimeModal: false });
          }}
        >
          <ModalBody className="row mx-0 px-4 py-3">
            <div className="col-12 px-0 py-3 align-self-center">
              <p className="fw-bold fs-5 mb-0">زمان ارسال</p>
            </div>
            <div className="col-12 px-0 py-3 align-self-center text-center">
              <DatePicker
                className="border text-center rounded14 bg-light-gray py-2 h-100 fw-bold color-main fs-5"
                isGregorian={false}
                timePicker={false}
                inputReadOnly={true}
                min={momentJalaali().add(-1, "day")}
                onChange={(value) =>
                  this.setState({ date: value }, () => this.setStartTimes())
                }
                value={this.state.date}
              />
            </div>
            <div className="col-6 px-0 py-2 align-self-center text-center">
              <p className="fw-bold text-end">از ساعت:</p>
              <Dropdown
                className="d-inline-block"
                isOpen={this.state.startSelect}
                toggle={() =>
                  this.setState({ startSelect: !this.state.startSelect })
                }
              >
                <DropdownToggle className="border color-main bg-light-gray">
                  {this.state.start_time}
                </DropdownToggle>
                <DropdownMenu
                  className="max-h-50 rounded-3"
                  style={{ minWidth: "80px" }}
                >
                  {this.state.start_times.map(
                    (time, t) =>
                      this.state.start_times.length - 1 !== t && (
                        <DropdownItem
                          className="text-center"
                          onClick={() =>
                            this.setState({ start_time: time }, () =>
                              this.setEndTimes()
                            )
                          }
                        >
                          {time}
                        </DropdownItem>
                      )
                  )}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="col-6 px-0 py-2 align-self-center text-center">
              <p className="fw-bold text-end">تا ساعت:</p>
              <Dropdown
                className="d-inline-block"
                isOpen={this.state.endSelect}
                toggle={() =>
                  this.setState({ endSelect: !this.state.endSelect })
                }
              >
                <DropdownToggle className="border color-main bg-light-gray">
                  {this.state.end_time}
                </DropdownToggle>
                <DropdownMenu
                  className="max-h-50 rounded-3"
                  style={{ minWidth: "80px" }}
                >
                  {this.state.end_times.map((time, t) => (
                    <DropdownItem
                      className="text-center"
                      onClick={() => this.setState({ end_time: time })}
                    >
                      {time}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="col-12 px-0 py-2 mt-3 align-self-center">
              <button
                onClick={() =>
                  this.setState({ setTimeModal: false, acceptModal: true })
                }
                className="btn w-100 rounded28 bg-color-main py-2 text-white fw-bold"
              >
                ذخیره
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default OrderDetailFooter;
